import { render, staticRenderFns } from "./document-status.vue?vue&type=template&id=88504b96&scoped=true&"
import script from "./document-status.vue?vue&type=script&lang=js&"
export * from "./document-status.vue?vue&type=script&lang=js&"
import style0 from "./document-status.vue?vue&type=style&index=0&id=88504b96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88504b96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88504b96')) {
      api.createRecord('88504b96', component.options)
    } else {
      api.reload('88504b96', component.options)
    }
    module.hot.accept("./document-status.vue?vue&type=template&id=88504b96&scoped=true&", function () {
      api.rerender('88504b96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/reports/documents/components/table/document-status.vue"
export default component.exports